
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'InputShowPassword',
    props: {
        active: {
            type: Boolean,
            default: true,
        },
    },
    emits: {
        change: () => true,
    },
    setup(props, { emit }) {
        const toggle = (): void => {
            emit('change');
        };
        return {
            toggle,
        };
    },
});
